// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mafia-countdown-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* Ключевой момент: клики проходят сквозь цифры */
  z-index: 1000000; 
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.mafia-countdown-number {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  font-weight: 900;
  font-size: 180px; /* Очень крупные */
  color: #d14e4e;
  text-shadow:
    0 0 10px rgba(0, 0, 0, 0.5),
    0 0 40px rgba(209, 78, 78, 0.4);
  opacity: 0;
  will-change: transform, opacity;
  animation: pulseNumber 0.9s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes pulseNumber {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  20% {
    transform: scale(1.4);
    opacity: 1;
  }
  40% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(0.8);
    opacity: 0; /* Исчезает к концу секунды */
  }
}

/* Нейтральный стиль (когда жертва уже выбрана) */
.mafia-countdown-number.neutral {
  font-size: 90px; /* В 2 раза меньше (было 180px) */
  color: #f0f0f0;  /* Бело-серый */
  text-shadow:
    0 0 10px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(255, 255, 255, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/components/mafia/helpers/MafiaCountdown.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAE,iDAAiD;EACvE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gGAAgG;EAChG,gBAAgB;EAChB,gBAAgB,EAAE,kBAAkB;EACpC,cAAc;EACd;;mCAEiC;EACjC,UAAU;EACV,+BAA+B;EAC/B,yEAAyE;AAC3E;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU,EAAE,6BAA6B;EAC3C;AACF;;AAEA,iDAAiD;AACjD;EACE,eAAe,EAAE,iCAAiC;EAClD,cAAc,GAAG,eAAe;EAChC;;qCAEmC;AACrC","sourcesContent":[".mafia-countdown-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none; /* Ключевой момент: клики проходят сквозь цифры */\n  z-index: 1000000; \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.mafia-countdown-number {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  font-weight: 900;\n  font-size: 180px; /* Очень крупные */\n  color: #d14e4e;\n  text-shadow:\n    0 0 10px rgba(0, 0, 0, 0.5),\n    0 0 40px rgba(209, 78, 78, 0.4);\n  opacity: 0;\n  will-change: transform, opacity;\n  animation: pulseNumber 0.9s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\n}\n\n@keyframes pulseNumber {\n  0% {\n    transform: scale(0.5);\n    opacity: 0;\n  }\n  20% {\n    transform: scale(1.4);\n    opacity: 1;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n  100% {\n    transform: scale(0.8);\n    opacity: 0; /* Исчезает к концу секунды */\n  }\n}\n\n/* Нейтральный стиль (когда жертва уже выбрана) */\n.mafia-countdown-number.neutral {\n  font-size: 90px; /* В 2 раза меньше (было 180px) */\n  color: #f0f0f0;  /* Бело-серый */\n  text-shadow:\n    0 0 10px rgba(0, 0, 0, 0.3),\n    0 0 20px rgba(255, 255, 255, 0.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
